import CartHeader from './CartHeader';
import useStyles from './styles';
import ProductPanel from '../Product/ProductPanel';
import SummaryPanel from '../Summary/SummaryPanel';
import AppFooter from '../App/AppFooter';
import Divider from '../../components/Divider/Divider';
import { BackTextButton } from '../App/Back';
import InstallmentPanelContainer from '../Payment/InstallmentPanelContainer';

function CartDetails() {
  const classes = useStyles();

  return (
    <div className={classes.container} data-testid="cartDetailsContainer">
      <CartHeader />
      <ProductPanel />
      <InstallmentPanelContainer />
      <Divider size="large" />
      <SummaryPanel />
      <Divider />
      <AppFooter />
      <BackTextButton />
    </div>
  );
}

export default CartDetails;
